var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Gambia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#33691e",
    d: "M42.716,31H5.284C8.125,38.588,15.421,44,24,44S39.875,38.588,42.716,31z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1a237e",
    d: "M44,24c0-1.37-0.139-2.707-0.402-4H4.402C4.139,21.293,4,22.63,4,24s0.139,2.707,0.402,4h39.197 C43.861,26.707,44,25.37,44,24z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M24,4C15.421,4,8.125,9.412,5.284,17h37.431C39.875,9.412,32.579,4,24,4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M42.716,17H5.284c-0.363,0.97-0.673,1.966-0.883,3h39.197C43.388,18.966,43.079,17.97,42.716,17z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M43.598,28H4.402c0.21,1.034,0.52,2.03,0.883,3h37.431C43.079,30.03,43.388,29.034,43.598,28z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Gambia);
export default __webpack_public_path__ + "static/media/icons8-gambia.584836dc443ed3c947d1a64bbee1b2ee.svg";
export { ForwardRef as ReactComponent };